"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDisbursementTotal;

function getDisbursementTotal(pa) {
  var totalValues = Number(pa.value) || 0 + Number(pa.valueIncome) || 0 + Number(pa.valueCommission) || 0 + Number(pa.valueOvertime) || 0;
  var totalDeductions = 0;
  Object.keys(pa.deductions).forEach(function (k) {
    if (!isNaN(pa.deductions[k])) totalDeductions += Number(pa.deductions[k] || 0);
  });

  if (pa.deductions.otherObligations && pa.deductions.otherObligations.length > 0) {
    pa.deductions.otherObligations.forEach(function (o) {
      totalDeductions += Number(o.value) || 0;
    });
  }

  return Number(totalValues) - Number(totalDeductions);
}